// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__wsNY5","label":"CategoryService_label__Eifel","location":"CategoryService_location__DVuZ3"};